function patientDiagnosisPermissionFactory(PatientSourceObjectPermission) {
  return PatientSourceObjectPermission;
}

patientDiagnosisPermissionFactory.$inject = ['PatientSourceObjectPermission'];

export default patientDiagnosisPermissionFactory;



/** WEBPACK FOOTER **
 ** ./src/app/patients/diagnoses/patient-diagnosis-permission.js
 **/